import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showWarn
    ? _c(
        "div",
        {
          staticClass: "review-card-resolved d-flex",
          class: _setup.isMobile ? "mt-4" : "text-body-2 success--text",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "review-card-resolved__body text-body-2",
              class: { "d-flex align-center ga-2": !_setup.isMobile },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.tStatic(
                      "Пациент отметил, что клиника решила проблему"
                    )
                  ) +
                  "\n    "
              ),
              _c(
                VMenu,
                {
                  attrs: {
                    attach: "",
                    "offset-y": "",
                    "z-index": _setup.isMobile ? 110 : 5,
                    "open-on-hover": !_setup.isMobile,
                    "max-width": _setup.isMobile ? 320 : 360,
                    "nudge-left": _setup.isMobile ? undefined : 56,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "review-card-resolved__hint link-decoration-underline success--text button-reset",
                                    class: { "text-body-2": !_setup.isMobile },
                                    attrs: { type: "button" },
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_setup.tStatic("Подробнее")) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3343653537
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    VCard,
                    {
                      staticClass: "pa-4 text-body-2",
                      attrs: { elevation: "0" },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_setup.hintText) + "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "review-card-resolved__icon d-flex align-center justify-center flex-shrink-0",
      },
      [_c("span", { staticClass: "ui-icon-hand-shaking" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }